import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { TunnelLocationIcon } from './TunnelLocationIcon';
import TunnelMarkerPopup from './TunnelMarkerPopup';
import { selectTunnelState } from "../../tunnelState/tunnelStateSlice";
import { isEmpty } from "../../../util/utils";
import { AutoOpenMarker } from "./AutoOpenMarker";

const TunnelMarkers = (props) => {
    const tunnelState = useSelector(selectTunnelState);
    const { t } = useTranslation();

    if (isEmpty(tunnelState)) {
        return null;
    }
    const { geomEast, geomWest, iconEast, iconWest, statusValueEast, statusValueWest,
        statusTextEast, statusTextWest } = tunnelState['tunnelStatus'];

    const titleEast = t('tunnel.east');
    const titleWest = t('tunnel.west');

    const markers = [
        <AutoOpenMarker key={'east'}
            position={{ lat: geomEast.coordinates[1], lng: geomEast.coordinates[0] }}
            title={titleEast}
            icon={TunnelLocationIcon}
            autoOpenId={'east'}>
            <TunnelMarkerPopup
                geom={geomEast}
                icon={iconEast}
                statusValue={statusValueEast}
                statusText={statusTextEast}
                title={titleEast}
                tunnelId={'east'}
            />
        </AutoOpenMarker>,
        <AutoOpenMarker key={'west'}
            position={{ lat: geomWest.coordinates[1], lng: geomWest.coordinates[0] }}
            title={titleWest}
            icon={TunnelLocationIcon}
            autoOpenId={'west'}>
            <TunnelMarkerPopup
                geom={geomWest}
                icon={iconWest}
                statusValue={statusValueWest}
                statusText={statusTextWest}
                title={titleWest}
                tunnelId={'west'}
            />
        </AutoOpenMarker>
    ];

    return <Fragment>{markers}</Fragment>
};

export default TunnelMarkers;
